// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"593":"0b53a2db","787":"6c8190cd","851":"d765964a"}[chunkId] + ".chunk.js";
};